import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const VoiceModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`NPC Voice`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`This is the voice you want the NPC to use when talking to the players.`)
                }} />
                <ul>
                    <li dangerouslySetInnerHTML={{
                        __html: t(`Use the preview tool to get to know the voices`)
                    }} />
                </ul>
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default VoiceModal;
